var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "profile-field__title" }, [_vm._v("Навыки")]),
    _vm.field.skills.language.show
      ? _c(
          "div",
          { staticClass: "skill-block" },
          [
            _vm._l(_vm.languages, function (item, i) {
              return _c("c-item", {
                key: item.unique,
                staticClass: "skill",
                attrs: {
                  item: item,
                  config: _vm.field.skills.language,
                  options: _vm.languageOptions,
                  "level-options": _vm.languageLevelOptions,
                  "skill-label": "Иностранный язык",
                  "can-remove": true,
                  error: _vm.error && _vm.error.languages.items[i],
                },
                on: {
                  remove: function ($event) {
                    return _vm.removeLanguage(item)
                  },
                },
              })
            }),
            _c("c-button", {
              attrs: {
                icon: { icon: "plus", color: "primary" },
                label: "Добавить язык",
                disabled: _vm.preview || _vm.hasEmptyLanguages,
                size: "small",
              },
              on: { click: _vm.addLanguage },
            }),
            _vm.error && _vm.error.languages.common
              ? _c("error-feedback", {
                  attrs: { text: _vm.error && _vm.error.languages.common },
                })
              : _vm._e(),
          ],
          2
        )
      : _vm._e(),
    _vm.field.skills.program.show
      ? _c(
          "div",
          { staticClass: "skill-block" },
          [
            _vm._l(_vm.programs, function (item, i) {
              return _c("c-item", {
                key: item.unique,
                staticClass: "skill",
                attrs: {
                  item: item,
                  config: _vm.field.skills.program,
                  options: _vm.programOptions,
                  "level-options": _vm.programLevelOptions,
                  "skill-label": "Программа",
                  "can-remove": true,
                  error: _vm.error && _vm.error.programs.items[i],
                },
                on: {
                  remove: function ($event) {
                    return _vm.removeProgram(item)
                  },
                },
              })
            }),
            _c("c-button", {
              attrs: {
                icon: { icon: "plus", color: "primary" },
                label: "Добавить программу",
                disabled: _vm.preview || _vm.hasEmptyPrograms,
                size: "small",
              },
              on: { click: _vm.addProgram },
            }),
            _vm.error && _vm.error.programs.common
              ? _c("error-feedback", {
                  attrs: { text: _vm.error && _vm.error.programs.common },
                })
              : _vm._e(),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }